import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-setting-page',
  templateUrl: './setting-page.component.html',
  styleUrls: ['./setting-page.component.scss']
})
export class SettingPageComponent implements OnInit {
aproposId;
visionId;
missionId;
actionnariatId;
programmeId;
eligibiliteId;
souscriptionId;
reclamationId;
tableauApropos:any =[];
tableauVision:any =[];
tableauMission:any = [];
tableauActionnaire:any = [];
tableauProgramme:any = [];
tableauEligibilite :any = [];
tableauSouscription:any = [];
tableauReclammation:any =[];
tableauEconomie:any = [];
tableauCreation:any =[];
tableauOrganisation:any = [];
tableauPromotion:any =[];
economieId;
creationId;
organisationId;
promotionId;
pages:any = [];
page:any = [];
hideLoader = true;
hideButon;
apropos;
vision;
mission;
actionnariat;
programme;
eligibilite;
souscription;
creation;
organisation;
reclammation;
economie;
promotion;


constructor(protected dialogRef: NbDialogRef<SettingPageComponent>,private apiservice:ApiService,public toastr:NbToastrService, private router: Router) { }

  ngOnInit() {
    this.getPage();
    this.getSettingPage();
  }


  getPage(){
    this.apiservice.getAllPageProvider().subscribe(data =>{
      this.pages = data;
    })
  }


  getSettingPage(){
    this.apiservice.getPageProvider().subscribe((data:any) =>{
      this.page.push(data) ;
      console.log( this.page);
      for (const key in this.page) {
        this.apropos = this.page[key].apropos.titre;
       this.programme =this.page[key].programme.titre;
       this.eligibilite =this.page[key].egibilite.titre;
        this.actionnariat = this.page[key].actionnariat.titre;
        this.souscription = this.page[key].souscription.titre;
        this.mission = this.page[key].mission.titre;
        this.vision = this.page[key].vision.titre;
        this.reclammation = this.page[key].reclamation.titre;
        this.economie = this.page[key].economie.titre;
        this.promotion = this.page[key].promotion.titre;
        this.creation = this.page[key].creation.titre;
        this.organisation = this.page[key].organisation.titre;
      
       
      }
      
    })
  }


  updatePage(){
    this.hideLoader = false;
    this.hideButon = true;
    console.log(this.aproposId);
    console.log(this.visionId);
    console.log(this.actionnariatId);
    this.apiservice.updateParametresPagesProvider(this.aproposId,this.visionId,this.missionId,this.actionnariatId,this.programmeId,this.eligibiliteId,this.souscriptionId,this.reclamationId,this.economieId,this.creationId,this.organisationId,this.promotionId).subscribe(data =>{
      console.log(data);
      this.toastr.success("mise à jour réussie","success");                                                     
     
      this.hideLoader = true;
      this.hideButon = false;
    },(err) =>{
      this.hideLoader = true;
      this.hideButon = false;
      this.toastr.danger("Echec de mise à jour","erreur");
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }


  dataChangedApropos($event){
    var id ;
    this.tableauApropos = [];
    this.tableauApropos= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauApropos) {
    id = this.tableauApropos[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauApropos) == -1){
      this.aproposId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauApropos);
    
    }
  
    console.log( this.aproposId);
   
   
  }



  dataChangedVision($event){
    var id ;
    this.tableauVision = [];
    this.tableauVision= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauVision) {
    id = this.tableauVision[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauVision) == -1){
      this.visionId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauVision);
    
    }
  
    console.log( this.visionId);
   
   
  }


  dataChangedMision($event){
    var id ;
    this.tableauMission = [];
    this.tableauMission= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauMission) {
    id = this.tableauMission[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauMission) == -1){
      this.missionId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauMission);
    
    }
  
    console.log( this.missionId);
   
   
  }

  dataChangedActionnariat($event){
    var id ;
    this.tableauActionnaire = [];
    this.tableauActionnaire= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauActionnaire) {
    id = this.tableauActionnaire[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauActionnaire) == -1){
      this.actionnariatId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauActionnaire);
    
    }
  
    console.log( this.actionnariatId);
   
   
  }

  dataChangedCreation($event){
    var id ;
    this.tableauCreation = [];
    this.tableauCreation= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauCreation) {
    id = this.tableauCreation[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauCreation) == -1){
      this.creationId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauCreation);
    
    }
  
    console.log( this.creationId);
  }

  dataChangedorganisation($event){
    var id ;
    this.tableauOrganisation = [];
    this.tableauOrganisation= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauOrganisation) {
    id = this.tableauOrganisation[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauOrganisation) == -1){
      this.organisationId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauOrganisation);
    
    }
  
    console.log( this.organisationId);
  }

  dataChangedEconomie($event){
    var id ;
    this.tableauEconomie = [];
    this.tableauEconomie= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauEconomie) {
    id = this.tableauEconomie[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauEconomie) == -1){
      this.economieId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauEconomie);
    
    }
  
    console.log( this.economieId);
  }

  dataChangedPromotion($event){
    var id ;
    this.tableauPromotion = [];
    this.tableauPromotion= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauPromotion) {
    id = this.tableauPromotion[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauPromotion) == -1){
      this.promotionId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauPromotion);
    
    }
  
    console.log( this.promotionId);
  }


  dataChangedProgramme($event){
    var id ;
    this.tableauProgramme = [];
    this.tableauProgramme= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauProgramme) {
    id = this.tableauProgramme[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauProgramme) == -1){
      this.programmeId = id
     
      return true;
    }else{
      this.remove(id,this.tableauProgramme);
    
    }
  
    console.log( this.programmeId);
   
   
  }


  dataChangedEligible($event){
    var id ;
    this.tableauEligibilite = [];
    this.tableauEligibilite= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauEligibilite) {
    id = this.tableauEligibilite[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauEligibilite) == -1){
      this.eligibiliteId = id
     
      return true;
    }else{
      this.remove(id,this.tableauEligibilite);
    
    }
  
    console.log( this.eligibiliteId);
   
   
  }


  dataChangedSouscription($event){
    var id ;
    this.tableauSouscription = [];
    this.tableauSouscription= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauSouscription) {
    id = this.tableauSouscription[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauSouscription) == -1){
      this.souscriptionId = id
     
      return true;
    }else{
      this.remove(id,this.tableauSouscription);
    
    }
  
    console.log( this.souscriptionId);
   
   
  }

  dataChangedReclamation($event){
    var id ;
    this.tableauReclammation = [];
    this.tableauReclammation= this.pages.filter(x => x.titre ===$event);
    
    for (const key in  this.tableauReclammation) {
    id = this.tableauReclammation[key].id;
    }
    console.log($event);
    if(this.recherche(id,this.tableauReclammation) == -1){
      this.reclamationId = id;
     
      return true;
    }else{
      this.remove(id,this.tableauReclammation);
    
    }
  
    console.log( this.reclamationId);
   
   
  }

  


  recherche(n, data: Array<any>) {
    let i = 0;
    let trouve: Boolean = false;

    while(i < data.length && !trouve){

       if( data[i] ==n){
         trouve = true;
       }else{
         i++;
       }
       
    }

    if(trouve){
         return i;
   }else{
     return - 1;
   }
   
 }

 cancel(){
  this.dialogRef.close();
}


 private remove(n, element:Array<any>){
  for( var i = 0; i <element.length; i++){ 
    if ( element[i] === n) {
      element.splice(i, 1); 
      i--;
    }
 }

 }

}
